import React from 'react';
import Tag from '../tag/Tag';
import { OptionType, RenderType, SelectionType } from './types';
import classNames from 'classnames';

interface Props {
  suffix?: JSX.Element | JSX.Element[] | string;
  prefix?: JSX.Element | JSX.Element[] | string;
  stablePrefix?: boolean;
  stableSuffix?: boolean;
  selectedValues: SelectionType;
  isSearchable: boolean;
  renderSelected: RenderType;
  removeSelectedValues: (removeOption: OptionType) => void;
  getSearchField: (
    hasPlaceholder: boolean,
  ) => string | JSX.Element | JSX.Element[];
  disabled?: boolean;
  showMenu?: boolean;
  isTextEllipsis?: boolean;
  isFixedWidthSelectedView?: boolean;
}

const SelectedPanel = ({
  prefix,
  stablePrefix,
  selectedValues,
  renderSelected,
  removeSelectedValues,
  isSearchable,
  getSearchField,
  suffix,
  stableSuffix,
  disabled,
  showMenu,
  isTextEllipsis,
  isFixedWidthSelectedView,
}: Props): string | JSX.Element | JSX.Element[] => {
  return (
    <div className="d-flex justify-content-between w-100">
      <div className="d-flex gap-4">
        {prefix && stablePrefix ? (
          <span className="me-1 d-flex align-items-center justify-content-center">
            {prefix}
          </span>
        ) : null}
        {Array.isArray(selectedValues) && selectedValues?.length ? (
          <div
            className={classNames('d-flex gap-2 w-100 flex-fill', {
              'flex-nowrap overflow-hidden': isFixedWidthSelectedView,
              'flex-wrap': !isFixedWidthSelectedView,
            })}
            style={{ ...(isFixedWidthSelectedView && { width: '300px' }) }}
          >
            {!renderSelected
              ? selectedValues?.map((selectedValue) => (
                  <Tag
                    key={selectedValue.value}
                    onClickClose={() => removeSelectedValues(selectedValue)}
                    label={selectedValue?.label || selectedValue?.value}
                    testId={String(selectedValue.value)}
                    testIdLabel={String(selectedValue.value)}
                    endIconType="close"
                    disabled={disabled}
                    isTextBreak={isFixedWidthSelectedView}
                  />
                ))
              : renderSelected(
                  selectedValues as OptionType[],
                  removeSelectedValues,
                )}
          </div>
        ) : !renderSelected ? (
          <div
            className={classNames('text-subtitle2', {
              'text-nowrap overflow-hidden text-ellipsis':
                isTextEllipsis && showMenu,
            })}
            style={{ ...(showMenu && isTextEllipsis && { width: '200px' }) }}
          >
            {(selectedValues as OptionType).label}
          </div>
        ) : (
          typeof selectedValues !== 'string' ||
          (selectedValues === 'number' ? renderSelected(selectedValues) : null)
        )}
        {isFixedWidthSelectedView ? '...' : null}
        {showMenu && isSearchable ? getSearchField(false) : null}
      </div>
      {suffix && stableSuffix ? (
        <span className="ms-1 d-flex align-items-center justify-content-center">
          {suffix}
        </span>
      ) : null}
    </div>
  );
};

export default SelectedPanel;
